module.exports = __webpack_public_path__ + "static/Sequence_CEP_960-8758bea35bc142a388f8542e4058cbf0.mp4";